import { render, staticRenderFns } from "./StepBuildingTypes.vue?vue&type=template&id=2ec2d733&"
import script from "./StepBuildingTypes.vue?vue&type=script&lang=js&"
export * from "./StepBuildingTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports